import {menuT} from '@/lib/types/nav.types';

export const ADMINMENUITEMS: menuT = [
  {
    menutitle: 'ADMIN',
  },
  {
    icon: <i className="side-menu__icon bx bx-home"></i>,
    type: 'link',
    Name: '',
    active: false,
    selected: false,
    title: 'Dashboards',
    path: `${import.meta.env.BASE_URL}admin/dashboard`,
    badge: '',
    badgetxt: '12',
    class: 'badge !bg-warning/10 !text-warning !py-[0.25rem] !px-[0.45rem] !text-[0.75em] ms-2',
  },
  {
    icon: <i className="side-menu__icon bx bx-user"></i>,
    type: 'link',
    active: false,
    selected: false,
    title: 'Positions',
    path: `${import.meta.env.BASE_URL}admin/positions`,
    badge: '',
    badgetxt: '42',
    class: 'badge !bg-warning/10 !text-warning !py-[0.25rem] !px-[0.45rem] !text-[0.75em] ms-2',
  },
  {
    icon: <i className="side-menu__icon bx bx-box"></i>,
    type: 'link',
    active: false,
    selected: false,
    title: 'Items',
    path: `${import.meta.env.BASE_URL}admin/items`,
    badge: '',
    badgetxt: '33',
    class: 'badge !bg-warning/10 !text-warning !py-[0.25rem] !px-[0.45rem] !text-[0.75em] ms-2',
  },

  {
    icon: <i className="side-menu__icon bx bx-money"></i>,
    type: 'link',
    active: false,
    selected: false,
    title: 'Transactions',
    path: `${import.meta.env.BASE_URL}admin/transactions`,
    badge: '',
    badgetxt: '12',
    class: 'badge !bg-warning/10 !text-warning !py-[0.25rem] !px-[0.45rem] !text-[0.75em] ms-2',
  },
  // invoice
  {
    icon: <i className="side-menu__icon bx bx-file"></i>,
    type: 'link',
    active: false,
    selected: false,
    title: 'Invoices',
    path: `${import.meta.env.BASE_URL}admin/invoices`,
    badge: '',
    badgetxt: '12',
    class: 'badge !bg-warning/10 !text-warning !py-[0.25rem] !px-[0.45rem] !text-[0.75em] ms-2',
  },
  {
    permission: 'super',
    icon: <i className="side-menu__icon bx bx-user"></i>,
    type: 'link',
    active: false,
    selected: false,
    title: 'Admins',
    path: `${import.meta.env.BASE_URL}admin/admins`,
    badge: '',
    badgetxt: '24',
    class: 'badge !bg-warning/10 !text-warning !py-[0.25rem] !px-[0.45rem] !text-[0.75em] ms-2',
  },
  {
    icon: <i className="side-menu__icon bx bx-area"></i>,
    type: 'link',
    active: false,
    selected: false,
    title: 'Markets',
    path: `${import.meta.env.BASE_URL}admin/markets`,
    badge: '',
    badgetxt: '5',
    class: 'badge !bg-warning/10 !text-warning !py-[0.25rem] !px-[0.45rem] !text-[0.75em] ms-2',
  },
  {
    icon: <i className="side-menu__icon bx bx-group"></i>,
    type: 'link',
    active: false,
    selected: false,
    title: 'Distributors',
    path: `${import.meta.env.BASE_URL}admin/distributors`,
    badge: '',
    badgetxt: '5',
    class: 'badge !bg-warning/10 !text-warning !py-[0.25rem] !px-[0.45rem] !text-[0.75em] ms-2',
  },
  {
    icon: <i className="side-menu__icon bx bx-tag"></i>,
    type: 'link',
    active: false,
    selected: false,
    title: 'Brands',
    path: `${import.meta.env.BASE_URL}admin/brands`,
    badge: '',
    badgetxt: '18',
    class: 'badge !bg-warning/10 !text-warning !py-[0.25rem] !px-[0.45rem] !text-[0.75em] ms-2',
  },
  {
    icon: <i className="side-menu__icon bx bx-package"></i>,
    type: 'link',
    active: false,
    selected: false,
    title: 'Products',
    path: `${import.meta.env.BASE_URL}admin/products`,
    badge: '',
    badgetxt: '42',
    class: 'badge !bg-warning/10 !text-warning !py-[0.25rem] !px-[0.45rem] !text-[0.75em] ms-2',
  },
  {
    icon: <i className="side-menu__icon bx bx-store"></i>,
    type: 'link',
    active: false,
    selected: false,
    title: 'Retailers',
    path: `${import.meta.env.BASE_URL}admin/retailers`,
    badge: '',
    badgetxt: '21',
    class: 'badge !bg-warning/10 !text-warning !py-[0.25rem] !px-[0.45rem] !text-[0.75em] ms-2',
  },
  {
    icon: <i className="side-menu__icon bx bx-transfer"></i>,
    type: 'link',
    active: false,
    selected: false,
    title: 'Orders',
    path: `${import.meta.env.BASE_URL}admin/orders`,
    badge: '',
    badgetxt: '33',
    class: 'badge !bg-warning/10 !text-warning !py-[0.25rem] !px-[0.45rem] !text-[0.75em] ms-2',
  },

  {
    icon: <i className="side-menu__icon bx bx-chart"></i>,
    type: 'link',
    active: false,
    selected: false,
    title: 'Speculators',
    path: `${import.meta.env.BASE_URL}admin/speculators`,
    badge: '',
    badgetxt: '8',
    class: 'badge !bg-warning/10 !text-warning !py-[0.25rem] !px-[0.45rem] !text-[0.75em] ms-2',
  },
  {
    icon: <i className="side-menu__icon bx bx-transfer-alt"></i>,
    type: 'link',
    active: false,
    selected: false,
    title: 'Metrc',
    path: `${import.meta.env.BASE_URL}admin/metrc`,
    badge: '',
    badgetxt: '8',
    class: 'badge !bg-warning/10 !text-warning !py-[0.25rem] !px-[0.45rem] !text-[0.75em] ms-2',
  },
  {
    icon: <i className="side-menu__icon bx bx-file"></i>,
    type: 'link',
    active: false,
    selected: false,
    title: 'Applications',
    path: `${import.meta.env.BASE_URL}admin/applications`,
    badge: '',
    badgetxt: '8',
    class: 'badge !bg-warning/10 !text-warning !py-[0.25rem] !px-[0.45rem] !text-[0.75em] ms-2',
  },
];

export const DISTRIBUTORMENUITEMS: menuT = [
  {
    menutitle: 'DISTRIBUTOR',
  },
  // {
  //   icon: <i className="side-menu__icon bx bx-home"></i>,
  //   type: 'link',
  //   Name: '',
  //   active: false,
  //   selected: false,
  //   title: 'Dashboard',
  //   path: `${import.meta.env.BASE_URL}distributor`,
  //   badge: '',
  //   badgetxt: '12',
  //   class: 'badge !bg-warning/10 !text-warning !py-[0.25rem] !px-[0.45rem] !text-[0.75em] ms-2',
  // },
  {
    icon: <i className="side-menu__icon ti ti-clipboard-list"></i>,
    type: 'link',
    Name: '',
    active: false,
    selected: false,
    title: 'Rate Sheets',
    path: `${import.meta.env.BASE_URL}distributor/rate-sheets`,
    badge: '',
    badgetxt: '12',
    class: 'badge !bg-warning/10 !text-warning !py-[0.25rem] !px-[0.45rem] !text-[0.75em] ms-2',
  },
  {
    icon: <i className="side-menu__icon ti ti-file"></i>,
    type: 'link',
    Name: '',
    active: false,
    selected: false,
    title: 'Orders',
    path: `${import.meta.env.BASE_URL}distributor/orders`,
    badge: '',
    badgetxt: '12',
    class: 'badge !bg-warning/10 !text-warning !py-[0.25rem] !px-[0.45rem] !text-[0.75em] ms-2',
  },
];

/**
 * Retailer Menu Items
 */
export const RETAILERMENUITEMS: menuT = [
  {
    menutitle: 'RETAILER',
  },
  {
    icon: <i className="side-menu__icon bx bx-home"></i>,
    type: 'link',
    Name: '',
    active: false,
    selected: false,
    title: 'Dashboard',
    path: `${import.meta.env.BASE_URL}retailer`,
    badge: '',
    badgetxt: '12',
    class: 'badge !bg-warning/10 !text-warning !py-[0.25rem] !px-[0.45rem] !text-[0.75em] ms-2',
  },
  {
    icon: <i className="side-menu__icon ti ti-file"></i>,
    type: 'link',
    Name: '',
    active: false,
    selected: false,
    title: 'Orders',
    path: `${import.meta.env.BASE_URL}retailer/orders`,
    badge: '',
    badgetxt: '12',
    class: 'badge !bg-warning/10 !text-warning !py-[0.25rem] !px-[0.45rem] !text-[0.75em] ms-2',
  },
  {
    icon: <i className="side-menu__icon bx bx-file"></i>,
    type: 'link',
    Name: '',
    active: false,
    selected: false,
    title: 'Invoices',
    path: `${import.meta.env.BASE_URL}retailer/invoices`,
    badge: '',
    badgetxt: '12',
    class: 'badge !bg-warning/10 !text-warning !py-[0.25rem] !px-[0.45rem] !text-[0.75em] ms-2',
  },
];

export const SPECULATORMENUITEMS: menuT = [
  {
    menutitle: 'SPECULATOR',
  },
  {
    icon: <i className="side-menu__icon bx bx-home"></i>,
    type: 'link',
    Name: '',
    active: false,
    selected: false,
    title: 'Dashboards',
    path: `${import.meta.env.BASE_URL}speculator/dashboard`,
    badge: '',
    badgetxt: '12',
    class: 'badge !bg-warning/10 !text-warning !py-[0.25rem] !px-[0.45rem] !text-[0.75em] ms-2',
  },
  {
    icon: <i className="side-menu__icon bx bx-area"></i>,
    type: 'link',
    active: false,
    selected: false,
    title: 'Positions',
    path: `${import.meta.env.BASE_URL}speculator/positions`,
    badge: '',
    badgetxt: '5',
    class: 'badge !bg-warning/10 !text-warning !py-[0.25rem] !px-[0.45rem] !text-[0.75em] ms-2',
  },
  {
    icon: <i className="side-menu__icon bx bx-box"></i>,
    type: 'link',
    active: false,
    selected: false,
    title: 'Items',
    path: `${import.meta.env.BASE_URL}speculator/items`,
    badge: '',
    badgetxt: '33',
    class: 'badge !bg-warning/10 !text-warning !py-[0.25rem] !px-[0.45rem] !text-[0.75em] ms-2',
  },
  {
    icon: <i className="side-menu__icon bx bx-package"></i>,
    type: 'link',
    active: false,
    selected: false,
    title: 'Products',
    path: `${import.meta.env.BASE_URL}speculator/products`,
    badge: '',
    badgetxt: '42',
    class: 'badge !bg-warning/10 !text-warning !py-[0.25rem] !px-[0.45rem] !text-[0.75em] ms-2',
  },
  // {
  //   icon: <i className="side-menu__icon bx bx-chart"></i>,
  //   type: 'link',
  //   active: false,
  //   selected: false,
  //   title: 'Reports',
  //   path: `${import.meta.env.BASE_URL}speculator/reports`,
  //   badge: '',
  //   badgetxt: '8',
  //   class: 'badge !bg-warning/10 !text-warning !py-[0.25rem] !px-[0.45rem] !text-[0.75em] ms-2',
  // },
  {
    icon: <i className="side-menu__icon bx bx-user"></i>,
    type: 'link',
    active: false,
    selected: false,
    title: 'Settings',
    path: `${import.meta.env.BASE_URL}speculator/settings`,
    badge: '',
    badgetxt: '24',
    class: 'badge !bg-warning/10 !text-warning !py-[0.25rem] !px-[0.45rem] !text-[0.75em] ms-2',
  },
  {
    icon: <i className="side-menu__icon bx bx-trophy"></i>,
    type: 'link',
    active: false,
    selected: false,
    title: 'Leaderboard',
    path: `${import.meta.env.BASE_URL}speculator/leaderboard`,
    badge: '',
    badgetxt: '33',
    class: 'badge !bg-warning/10 !text-warning !py-[0.25rem] !px-[0.45rem] !text-[0.75em] ms-2',
  },
];
